import { resolveMediaUrl } from "./resolveMediaUrl";

const PENDING_USER_KEY = "simcollect.provider.pendingUser";

/** Map backend status → display string for badges / lockout. */
export function formatAccountStatus(status) {
  if (status === true || status === 1 || status === "1" || status === "active") return "active";
  if (status === false || status === 0 || status === "0" || status === "inactive") return "inactive";
  if (status === "suspended") return "suspended";
  if (typeof status === "string") return status.toLowerCase();
  return "active";
}

export function normalizePhoneNumber(phone) {
  if (!phone) return "";
  const value = String(phone).trim();
  if (value.startsWith("+")) return value;
  if (/^\d+$/.test(value)) return `+${value}`;
  return value;
}


/**
 * Map Laravel provider verify payload → Redux user.
 * Strips token fields (stored separately on auth slice).
 */
export function normalizeProviderUser(raw, loginEmail = "") {
  if (!raw || typeof raw !== "object") return null;

  const {
    token: _token,
    access_token: _accessToken,
    auth_token: _authToken,
    bearer_token: _bearerToken,
    token_type: _tokenType,
    expires_in: _expiresIn,
    permissions: _permissions,
    is_institution_account: _legacyAccountFlag,
    institution_id: _legacyInstitutionId,
    institution_code: _legacyInstitutionCode,
    sla_days: _opsSlaDays,
    ...fields
  } = raw;

  const email =
    (fields.primary_email || fields.email || loginEmail || "").trim().toLowerCase() || "";
  const displayName =
    fields.legal_name || fields.name || fields.institution || email.split("@")[0] || "Provider user";
  const phoneRaw =
    fields.primary_phone_number || fields.phone || fields.phone_number || null;

  const providerId = fields.provider_id ?? fields.id ?? null;

  return {
    id: providerId,
    provider_id: providerId,
    legal_name: fields.legal_name || displayName,
    name: displayName,
    email,
    phone: normalizePhoneNumber(phoneRaw),
    phone_number: phoneRaw != null ? String(phoneRaw) : null,
    primary_email: email,
    primary_phone_number: phoneRaw != null ? String(phoneRaw) : null,
    status: formatAccountStatus(fields.status),
    email_verified_at: fields.email_verified_at ?? null,
    last_login_at: fields.last_login_at ?? null,
    created_at: fields.created_at ?? null,
    updated_at: fields.updated_at ?? null,
    deleted_at: fields.deleted_at ?? null,
    institution: fields.legal_name || fields.name || "",
    code: fields.code ?? null,
    business_type: fields.business_type ?? fields.type ?? null,
    type: fields.business_type ?? fields.type ?? null,
    region: fields.region ?? null,
    city: fields.city ?? null,
    gps_address: fields.gps_address ?? null,
    website: fields.website ?? null,
    logo: resolveMediaUrl(fields.logo ?? null),
    secondary_email: fields.secondary_email ?? null,
    secondary_phone_number: fields.secondary_phone_number ?? null,
    socials: fields.socials ?? null,
    channels: fields.channels
      ? {
          sms: Boolean(fields.channels.sms),
          whatsapp: Boolean(fields.channels.whatsapp),
          email: Boolean(fields.channels.email),
        }
      : null,
    agreed_sla_days:
      fields.agreed_sla_days != null
        ? Number(fields.agreed_sla_days)
        : fields.contract_sla_days != null
          ? Number(fields.contract_sla_days)
          : null,
  };
}

export function extractTokenFromPayload(raw) {
  if (!raw || typeof raw !== "object") return null;
  return raw.token ?? raw.access_token ?? raw.auth_token ?? raw.bearer_token ?? null;
}

export function savePendingProviderUser(user) {
  if (!user) {
    sessionStorage.removeItem(PENDING_USER_KEY);
    return;
  }
  sessionStorage.setItem(PENDING_USER_KEY, JSON.stringify(user));
}

export function clearPendingProviderUser() {
  sessionStorage.removeItem(PENDING_USER_KEY);
}
